import { createTermTagManager } from '../../utils/createTermTagManager';

export const userIdTagManager = createTermTagManager({
  jsonQueryKey: 'id_user',
  template: 'Агент №%s',
  id: 'userId',
});
